import React, { type ReactElement } from 'react';
import './../../pg/Global.css';
import './../Palette.css';
import './ImageParagraph.css';

type ImageParagraphProps = {
    Header: string,
    Paragrahps: ReactElement,
    Type: string,
    Img: string,
    MaxHeight: number,
};



const ImageParagraph: React.FC<ImageParagraphProps> = ({ Header, Type, Paragrahps, Img, MaxHeight }) => {
    if (Type === 'alt') {
        return (
            <div className='ImgSplitterWrap' >
                <div className='ImgSplitterWrapCenter' style={{ height: MaxHeight }}>
                    <ul className='ImgSplitter'>
                        <li className='ImgRigthSide'>
                            <div className='ImgHeader'>
                                <h3>{Header}</h3>
                            </div>
                            <div className='ImgParagraph'>
                                {Paragrahps}
                            </div>
                        </li>
                        <li className='ImgLeftSide ImgLeftSideAlt'>
                            <img src={Img} />
                        </li>
                    </ul>
                </div>
            </div>
        );
    } else {
        return (
            <div className='ImgSplitterWrap' >
                <div className='ImgSplitterWrapCenter' style={{ height: MaxHeight }}>
                    <ul className='ImgSplitter'>
                        <li className='ImgLeftSide'>
                            <img src={Img} />
                        </li>
                        <li className='ImgRigthSide'>
                            <div className='ImgHeader'>
                                <h3>{Header}</h3>
                            </div>
                            <div className='ImgParagraph'>
                                {Paragrahps}
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        );
    }
};

export default ImageParagraph;


